import Cookie from './Cookie';

export const isSpam = (name?: string, overrideSpam = false): boolean => {
  if (!name || overrideSpam) {
    return false;
  }

  return !!Cookie.getCookie('quali-global-asked') || !!Cookie.getCookie(`${name}-asked`);
};

export const setAsked = (name?: string, overrideSpam = false): void => {
  if (!name || overrideSpam) {
    return;
  }

  Cookie.setCookie(`${name}-asked`, 'asked', 30);
  Cookie.setCookie('quali-global-asked', 'asked', 30);
};

export const getIdentifier = (identifierType: string, identifier?: string) => {
  if (identifier) {
    return identifier;
  }

  if (identifierType === 'UserId') {
    return Cookie.getUserId();
  }

  return undefined;
};
